<template>
  <div class="project-detail-info">

    <div class="cust-info">
      <div class="title"> <span>客户信息</span> </div>
      <div class="info-box">
        <el-row :gutter="20">
          <el-col :span="16">
            <el-form-item label="合作单位：" prop="partner">
              <el-input v-model="detailForm.partner" placeholder="请输入单位名称" :disabled='disabled'></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="联 系 人 ：" prop="custName">
              <el-input v-model="detailForm.custName" placeholder="请输入名字" :disabled='disabled'></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="客户职务：" prop="custJob">
              <el-input v-model="detailForm.custJob" placeholder="请输入职务名称" :disabled='disabled'></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="客户电话：" prop="custPhone">
              <el-input v-model="detailForm.custPhone" placeholder="请输入电话号码" :disabled='disabled'></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="客户微信：" prop="custWechat">
              <el-input v-model="detailForm.custWechat" placeholder="请输入微信账号" :disabled='disabled'></el-input>
            </el-form-item>
          </el-col>

        </el-row>
      </div>
    </div>
    <div class="project-info">
      <div class="title"> <span>项目概况</span> </div>
      <div class="info-box">
        <el-row type="flex">
          <el-form-item label="培训地区：" prop="area" class="full-width">
            <el-input v-model="detailForm.area" placeholder="请输入培训地区" :disabled='disabled'></el-input>
          </el-form-item>
          <!-- <el-form-item label="培训地区：" prop="province">
            <el-select v-model="detailForm.province" placeholder="请选择省份" @change='selectProvince' :disabled='disabled'>
              <el-option v-for="(province,key) in provinceMap" :key="key" :label="province.name" :value="key">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="省" prop="city" label-width='50px'>
            <el-select v-model="detailForm.city" placeholder="请选择地市" @change="selectCity" :disabled='disabled'>
              <el-option v-for="(city,key) in cityMap" :key="key" :label="city.name" :value="key">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="市" prop="area" label-width='50px'>
            <el-select v-model="detailForm.area" placeholder="请选择区县" @change="$forceUpdate()" :disabled='disabled'>
              <el-option v-for="(area,key) in areaMap" :key="key" :label="area" :value="area">
              </el-option>
            </el-select>
          </el-form-item>
          <span class="addr-type">区（县）</span> -->
        </el-row>
        <el-row type="flex">
          <el-form-item label="项目级别：" prop="prejectLevel">
            <el-select v-model="detailForm.prejectLevel" :disabled='disabled'>
              <el-option v-for="(value,key) in projectLevelMap" :key="key" :label="value" :value="key">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="服务等级：" prop="serviceLevel">
            <el-select v-model="detailForm.serviceLevel" :disabled='disabled'>
              <el-option v-for="(value,key) in serviceLevelMap" :key="key" :label="value" :value="key">
              </el-option>
            </el-select>
          </el-form-item>
        </el-row>
        <el-row type="flex">
          <el-form-item label="培训模式：" prop="mode">
            <el-select v-model="detailForm.mode" :disabled='disabled'>
              <el-option v-for="(value,key) in modeMap" :key="key" :label="value" :value="key">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="培训内容：" prop="content">
            <el-select v-model="detailForm.content" :disabled='disabled'>
              <el-option v-for="(value,key) in contentMap" :key="key" :label="value" :value="key">
              </el-option>
            </el-select>
          </el-form-item>
        </el-row>
      </div>
    </div>
    <div class="project-object">
      <div class="title"> <span>项目对象</span> </div>
      <div class="info-box">
        <el-row type="flex">
          <el-form-item label="学 段：" prop="stage">
             <!-- <el-select v-model="stage" multiple :disabled='disabled'>
              <el-option v-for="(value,key) in stageMap" :key="key" :label="value" :value="key">
              </el-option>
            </el-select>  -->
            <el-input v-model="detailForm.stage" :disabled='disabled'></el-input>

          </el-form-item>
          <el-form-item label="学 科：" prop="subject">
            <el-input v-model="detailForm.subject" :disabled='disabled'></el-input>
             <!-- <el-select v-model="subject" multiple :disabled='disabled'>
              <el-option v-for="(value,key) in subjectMap" :key="key" :label="value" :value="key+''">
              </el-option>
            </el-select>  -->
          </el-form-item>
        </el-row>
        <el-row type="flex" class="input-area">
          <el-form-item label="培训规模：" prop="scale">
            <el-input v-model.number="detailForm.scale" :disabled='disabled'></el-input>
          </el-form-item>

          <!-- <el-form-item label="培训学时：" class="train-day" prop="days" style="margin-left:54px">
            <el-input v-model.number="detailForm.days" :disabled='disabled'></el-input>
          </el-form-item> -->
        </el-row>
      </div>
    </div>
    <div class="project-time">
      <div class="title"> <span>培训周期</span> </div>
      <div class="info-box">
        <el-row type="flex">
          <el-form-item label="起始时间：" prop="trainDate" :rules=" [{type: 'array', required: true, message: '起始时间不能为空',trigger: 'change' }]">
            <el-date-picker v-model="detailForm.trainDate" :value-format="'yyyy-MM-dd HH:mm:ss'" type="datetimerange" :picker-options="pickerOptions" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" align="right" @change='selectDate' :disabled='disabled' @input="$forceUpdate()">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="学  时：" class="train-hour" prop="days">
            <el-input v-model.number="detailForm.days" :disabled='disabled'></el-input>
          </el-form-item>
        </el-row>
        <el-row type="flex">
          <el-form-item label="天  数：" class="train-day">
            <el-input v-model="detailForm.trainDays" :disabled='disabled' readonly></el-input>
            <!-- <span class="addr-type"> 区（县）</span> -->
          </el-form-item>
          <el-form-item label="地  点：" prop="trainAddr" :rules="[{ required: true, message: '地点不能为空',trigger: 'blur' }]">
            <el-input v-model="detailForm.trainAddr" :disabled='disabled' clearable></el-input>
          </el-form-item>
        </el-row>
      </div>
    </div>
    <div class="project-fee">
      <div class="title"> <span>培训经费</span> </div>
      <div class="info-box">
        <el-row type="flex" class="input-area">
          <el-form-item label="培训单价：" class="unit-cost" prop="unitCost">
            <el-input v-model.number="detailForm.unitCost" :disabled='disabled'></el-input>
          </el-form-item>
          <el-form-item label="总 经 费 ：" class="total-cost" prop="totalCost">
            <el-input v-model.number="totalCost" :disabled='disabled'></el-input>
          </el-form-item>
        </el-row>
      </div>
    </div>
    <div class="project-time">
      <div class="title"> <span>项目调研</span> </div>
      <div class="info-box">
        <el-row type="flex">
          <el-form-item label="起始时间：" prop="surveyDate">
            <el-date-picker v-model="detailForm.surveyDate" :value-format="'yyyy-MM-dd HH:mm:ss'" type="datetimerange" :picker-options="pickerOptions" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" align="right" @change='selectDate2' :disabled='disabled' @input="$forceUpdate()">
            </el-date-picker>
          </el-form-item>
        </el-row>
        <el-row type="flex">
          <el-form-item label="天  数：" class="train-day">
            <el-input v-model="detailForm.surveyDays" :disabled='disabled' readonly></el-input>
          </el-form-item>
          <el-form-item label="地  点：" prop="surveyAddr">
            <el-input v-model="detailForm.surveyAddr" :disabled='disabled' clearable></el-input>
          </el-form-item>
        </el-row>
      </div>
    </div>

    <div class="project-time">
      <div class="title"> <span>总结会</span> </div>
      <div class="info-box">
        <el-row type="flex">
          <el-form-item label="起始时间：" prop="summaryDate">
            <el-date-picker v-model="detailForm.summaryDate" :value-format="'yyyy-MM-dd HH:mm:ss'" type="datetimerange" :picker-options="pickerOptions" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" align="right" @change='selectDate1' :disabled='disabled' @input="$forceUpdate()">
            </el-date-picker>
          </el-form-item>
        </el-row>
        <el-row type="flex">
          <el-form-item label="天  数：" class="train-day">
            <el-input v-model="detailForm.summaryDays" :disabled='disabled' readonly></el-input>
          </el-form-item>
          <el-form-item label="地  点：" prop="summaryAddr">
            <el-input v-model="detailForm.summaryAddr" :disabled='disabled' clearable></el-input>
          </el-form-item>
        </el-row>
      </div>
      <el-form-item label="培训要求：">
        <el-input type="textarea" :autosize="{ minRows: 4, maxRows: 4}" placeholder="请在下方输入内容" v-model="detailForm.require" :disabled='disabled'>
        </el-input>
      </el-form-item>
    </div>

  </div>

</template>

<script>
import addr from '../../common/addr'
import commonData from '../../common/commonData'
import moment from 'moment'


export default {
  components: {

  },
  props: {
    detailForm: {
      type: Object,
      default: function () {
        return {}
      }
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      province: "",
      city: "",
      provinceMap: {},
      cityMap: {},
      areaMap: {},
      projectLevelMap: {},
      serviceLevelMap: {},
      modeMap: {},
      contentMap: {},
      stageMap: {},
      subjectMap: {},
      pickerOptions: {},
    };
  },
  computed: {

  },
  watch: {

  },
  created() {

  },
  mounted() {
    this.provinceMap = addr.addrData()
    this.projectLevelMap = commonData.projectLevel
    this.serviceLevelMap = commonData.serviceLevel
    this.modeMap = commonData.mode
    this.contentMap = commonData.content
    this.stageMap = commonData.stage
    this.subjectMap = commonData.subject
    this.pickerOptions = commonData.pickerOptions
   
  },
  methods: {
    selectProvince(key) {
      this.cityMap = this.provinceMap[key].child
      this.$set(this.detailForm, 'province', this.provinceMap[key].name)
      let cityKey = Object.keys(this.cityMap)[0]
      this.$set(this.detailForm, 'city', this.cityMap[cityKey].name)
      this.city = this.cityMap[cityKey].name
      this.areaMap = this.cityMap[cityKey].child
      let areaKey = Object.keys(this.areaMap)[0]
      this.$set(this.detailForm, 'area', this.areaMap[areaKey])
      console.log(this.areaMap)
    },
    selectCity(key) {
      this.areaMap = this.cityMap[key].child
      this.$set(this.detailForm, 'area', this.areaMap[Object.keys(this.areaMap)[0]])

    },
    addTrip(index) {
      console.log("addTrip", typeof (index) == 'number');
      if (typeof (index) == 'number') {
        this.detailForm.tripList.splice(index, 1)
      } else {
        this.detailForm.tripList.push({})
      }
    },
    selectDate(dateArr) {
      this.$forceUpdate()
      console.log("selectDate", dateArr)
      if (dateArr && dateArr.length) {
        var start = moment(dateArr[0]).format('YYYY-MM-DD')
        var end = moment(dateArr[1]).format('YYYY-MM-DD')
        let days = moment(end).diff(start, 'day')+1
        this.$set(this.detailForm, 'trainDays', days)
        this.$set(this.detailForm, 'trainStartTime', dateArr[0])
        this.$set(this.detailForm, 'trainEndTime', dateArr[1])
      }
    },
    selectDate1(dateArr) {
      this.$forceUpdate()
      console.log("selectDate1", dateArr)
      if (dateArr && dateArr.length) {
        var start = moment(dateArr[0]).format('YYYY-MM-DD')
        var end = moment(dateArr[1]).format('YYYY-MM-DD')
        let days = moment(end).diff(start, 'day')+1
        this.$set(this.detailForm, 'summaryDays', days)
        this.$set(this.detailForm, 'summaryStartTime', dateArr[0])
        this.$set(this.detailForm, 'summaryEndTime', dateArr[1])
      }
    },
    selectDate2(dateArr) {
      this.$forceUpdate()
      console.log("selectDate2", dateArr)
      if (dateArr && dateArr.length) {
        var start = moment(dateArr[0]).format('YYYY-MM-DD')
        var end = moment(dateArr[1]).format('YYYY-MM-DD')
        let days = moment(end).diff(start, 'day')+1
        this.$set(this.detailForm, 'surveyDays', days)
        this.$set(this.detailForm, 'surveyStartTime', dateArr[0])
        this.$set(this.detailForm, 'surveyEndTime', dateArr[1])
      }
    }
  },
  computed: {
    totalCost: {
      get() {
        console.log("this.detailForm.totalCost", this.detailForm.totalCost);
        let cost = this.detailForm.totalCost
        if (cost) {
          return cost / 100
        }
        return ''
      },
      set(val) {
        val = parseInt(val) * 100
        this.$set(this.detailForm, 'totalCost', val)
        console.log("totalCost", this.detailForm.totalCost);
      }
    },
    stage: {
      get() {
        console.log("this.detailForm.stage", this.detailForm.stage);
        let stage = this.detailForm.stage
        if (stage) {
          return stage.split(',')
        }
        return []
      },
      set(val) {

        this.$set(this.detailForm, 'stage', val.join())
        console.log("stage", this.detailForm.stage);
      }
    },
    subject: {
      get() {
        console.log("this.detailForm.subject", this.detailForm.subject);
        let subject = this.detailForm.subject
        if (subject) {
          return subject.split(',')
        }
        return []
      },
      set(val) {

        this.$set(this.detailForm, 'subject', val.join())
        console.log("subject", this.detailForm.subject);
      }
    },
  }
};
</script>

<style  lang="less"  >
.project-detail-info {
  padding: 20px 40px 0px 40px;
  .title {
    border-bottom: 1px solid #ebeef5;
    font-size: 16px;
    margin-bottom: 20px;
    padding: 0px 0 20px 0;
    span {
      display: block;
      padding-left: 20px;
      position: relative;
      &::before {
        position: absolute;
        content: "";
        width: 4px;
        height: 20px;
        background: #346aff;
        opacity: 1;
        display: block;
        left: 0px;
        top: 1px;
      }
    }
  }
  .input-area {
    .el-input {
      &::after {
        display: inline-block;
        position: absolute;
        right: 10px;
        content: "人";
      }
    }
    .el-input__inner {
      width: 180px;
      position: relative;
    }
    .train-day .el-input::after {
      content: "天";
    }
    .train-hour .el-input::after {
      content: "学时";
    }
    .unit-cost .el-input::after {
      content: "元/天/人";
    }
    .total-cost .el-input::after {
      content: "元";
    }
  }
  .info-box {
    position: relative;
    .el-row--flex {
      .el-input__inner {
        // width: 150px;
      }
      .el-date-editor--datetimerange {
        width: auto;
      }
      .full-width {
        width: 100%;
      }
    }
    .el-input__inner {
      min-width: 150px;
      position: relative;
    }
    .el-form-item + .el-form-item {
      margin-left: 40px;
    }
    .addr-type {
      margin: 0 20px;
      white-space: nowrap;
      font-size: 14px;
      line-height: 30px;
    }
    .addr-type:last-child {
      margin-right: 0;
    }
    .train-day .el-input::after {
      content: "天";
      display: inline-block;
      position: absolute;
      right: 10px;
    }
    .train-hour .el-input::after {
      content: "学时";
      display: inline-block;
      position: absolute;
      right: 10px;
    }
    .btns {
      position: absolute;
      right: 20px;
      top: 20px;
    }
  }

  @media screen and (max-width: 1366px) {
    .el-row--flex,
    .el-col-8 {
      .el-input__inner {
        // width: 150px;
      }
    }
    .el-input__inner {
      min-width: 120px !important;
    }
  }
  @media screen and(min-width: 1441px) and (max-width: 1920px) {
    .el-row--flex {
      .el-input__inner {
        // width: 200px !important;
      }
    }
  }
}
</style>

